import { LinkCatalog } from 'components/system/LinkCatalog';
import React, { FC } from 'react';

import { Link } from 'reactComponents/Link/Link';

const TryLater: FC = ({ children }) => {
    return (
        <>
            {children} Попробуйте позже или обратитесь в{' '}
            <Link href={LinkCatalog.getInfraSupportUrl()}>
                службу поддержки
            </Link>
            .
        </>
    );
};

const AskLimitsIncrease: FC = ({ children }) => {
    return (
        <>
            {children} Для увеличения лимитов обратитесь, пожалуйста, в{' '}
            <Link href={LinkCatalog.getInfraSupportUrl()}>
                службу поддержки
            </Link>
            .
        </>
    );
};

const CallSupport: FC = ({ children }) => {
    return (
        <>
            {children} Пожалуйста, обратитесь в{' '}
            <Link href={LinkCatalog.getInfraSupportUrl()}>
                службу поддержки
            </Link>
            .
        </>
    );
};

export const McsErrors = {
    TryLater,
    CallSupport,
    AskLimitsIncrease,
};
